import {makeStyles} from '@material-ui/core'

export default makeStyles(theme => ({
  root: {
    height: '100%',
    borderRadius: 8,
    boxShadow: theme.shadows[5],
  },
}))
